import {
  MfaEnablePost200Response,
  MfaEnableVerifyPostRequest,
  MfaEnableVerifyPost200Response,
  MfaEnableVerifyPost400Response,
} from '@openapi';
import { getMfaApi } from './configuration';

const mfa = {
  enable: (): Promise<MfaEnablePost200Response> => {
    return getMfaApi().mfaEnablePost();
  },

  verify: (
    params: MfaEnableVerifyPostRequest,
  ): Promise<MfaEnableVerifyPost200Response | MfaEnableVerifyPost400Response> => {
    return getMfaApi().mfaEnableVerifyPost({ mfaEnableVerifyPostRequest: params });
  },

  disable: (
    params: MfaEnableVerifyPostRequest,
  ): Promise<MfaEnableVerifyPost200Response | MfaEnableVerifyPost400Response> => {
    return getMfaApi().mfaDisablePost({ mfaEnableVerifyPostRequest: params });
  },

  getQrCode: (): Promise<Blob> => {
    return getMfaApi()
      .mfaQrcodeGet()
      .then((res) => {
        // backend returns PNG image
        return res as unknown as Blob;
      });
  },
};

export default mfa;
